import { useEffect, useState } from 'react'
import { exctractDataFromFiles } from '../lib/utilities/exctractDataFromFiles';
import DropZone from './DropZone';
import { xyExtraction } from '../lib/utilities/xyExtraction';
import { peakFinderAPI, resultCreatorAPI } from '../api/api';


function UploadFiles(props) {


    const [RecievedFiles, setRecievedFiles] = useState([]);
    const [loadingProgress, setLoadingProgress] = useState({});
    const [isProcessing, setIsProcessing] = useState(false);

  const handleInputFiles = (newFiles) => {
    // Pass through if processed OR if it's an explicit empty array (deleting everything)
    const isArray = Array.isArray(newFiles);
    const isEmptyArray = isArray && newFiles.length === 0;
    // Check for processed files - handle both old structure and new structure
    const processed = isArray && newFiles.length > 0 && (
      newFiles[0].originalData || 
      newFiles[0].result || 
      newFiles[0].fileData?.originalData || 
      newFiles[0].fileData?.result
    );
    if (processed || isEmptyArray) {
      props.handleFileInput(newFiles);
    } else {
      setRecievedFiles(newFiles);
    }
  };

    const handleFileName = (fileName) => {
      props.handleFileName(fileName)
  }

    useEffect(() => {
      if (Array.isArray(RecievedFiles) && RecievedFiles.length > 0) {
        manipulateDatafromFiles();
      }
    },[RecievedFiles])



    const manipulateDatafromFiles = async () => {
      setIsProcessing(true); // Start processing - disable DnD
      const resultDataArray = await exctractDataFromFiles(RecievedFiles);
      const resultDataArrayWithXYExtraction = await xyExtraction(resultDataArray);
      const finalFilesArray = [];
      for (const item of resultDataArrayWithXYExtraction) {
        try {
          setLoadingProgress(prev => ({ ...prev, [item.name]: 10 }));

          const peaksIndices = await peakFinderAPI(item.originalXValues, item.originalYValues);
          setLoadingProgress(prev => ({ ...prev, [item.name]: 40 }));

          const peaksXValues = [];
          const peaksYValues = [];
          peaksIndices.forEach(index => {
            peaksXValues.push(item.originalXValues[index]);
            peaksYValues.push(item.originalYValues[index]);
          });

          const resultObject = await resultCreatorAPI(item.originalXValues, item.originalYValues, peaksIndices, peaksXValues);
          setLoadingProgress(prev => ({ ...prev, [item.name]: 80 }));

          setLoadingProgress(prev => ({ ...prev, [item.name]: 100 }));
          setTimeout(() => {
            setLoadingProgress(prev => ({ ...prev, [item.name]: null }));
          }, 1000);

          finalFilesArray.push({
            fileName: item.name,
            fileData: {
              originalData: item.originalData,
              originalXValues: item.originalXValues,
              originalYValues: item.originalYValues,
              peaksIndices,
              peaksXValues,
              peaksYValues,
              result: resultObject
            }
          });
        } catch (error) {
          console.error(`Error processing file ${item.name}:`, error);
        }
      }
      props.handleFileInput(finalFilesArray);
      
      // Wait a bit for final animations to complete, then re-enable DnD
      setTimeout(() => {
        setIsProcessing(false);
      }, 1500);
    };


  return (
    <div className='flex flex-col'>
      <DropZone
        moreColors={props.moreColors}
        showHelpText={props.showHelpText}
        handleInputFiles={handleInputFiles}
        handleFileName={handleFileName}
        level={props.level}
        loadingProgress={loadingProgress}
        initialFiles={props.initialFiles}
        enableReorder={props.enableReorder && !isProcessing}
      />
    </div>
  )
}

export default UploadFiles